export default function isNumber(value) {
    return typeof value === "number";
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/common/is-number.js
// module id = 234
// module chunks = 93